import { Controller } from "@hotwired/stimulus"

// Radio-card / segmented picker. Each option is a <label> wrapping a
// visually-hidden radio plus the visible card; clicking the label natively
// checks the radio. This toggles the `is-selected` class onto whichever
// card holds the now-checked radio so the highlight follows the click.
//
// A CSS `.radio-card:has(input:checked)` rule provides the same highlight
// with no JS, so this controller is purely progressive enhancement.
//
//   <div data-controller="segmented-radio">
//     <label data-segmented-radio-target="option">
//       <input type="radio" class="sr-only"> …
//     </label>
//     <label data-segmented-radio-target="option">…</label>
//   </div>
export default class extends Controller {
  static targets = ["option"]

  connect() {
    this._onChange = this._onChange.bind(this)
    this.element.addEventListener("change", this._onChange)
    this._sync()
  }

  disconnect() {
    this.element.removeEventListener("change", this._onChange)
  }

  _onChange(event) {
    if (event.target.matches('input[type="radio"]')) this._sync()
  }

  _sync() {
    this.optionTargets.forEach((label) => {
      const radio = label.querySelector('input[type="radio"]')
      if (radio) label.classList.toggle("is-selected", radio.checked)
    })
  }
}
